import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import locale from 'locale';
import {getGlobalSettings, createBlock, deleteBlock, editBlock, getBlocks} from '../../../../api/cp';
import {blockModel} from './models';

import {Breadcrumb, Row, Col, Button, Alert} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import BlocksList from './BlocksList'
import BlocksEditModal from './BlocksModals/BlocksEditModal';
import BlocksModalPreview from './BlocksModals/BlocksModalPreview';
import {useNotificationContext} from '../../UI/Notifications';

const BlockConstructor = ({event}) => {
    const [mailSettings, setMailSettings] = useState(null);
    const [blocksList, setBlocksList] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [editableModel, setEditableModel] = useState(blockModel);
    const [isModalPreviewVisible, setIsModalPreviewVisible] = useState(false);
    const [previewBlock, setPreviewBlock] = useState(null);
    const {showNotification} = useNotificationContext();

    useEffect(async () => {
        getBlocksList();
        const data = await getGlobalSettings(event.eventPassword);
        setMailSettings(data);
    }, []);

    async function getBlocksList() {
        try {
            const blocks = await getBlocks(event.eventKey);
            setBlocksList(blocks || []);
        } catch ({message = null}) {
            if (message) showNotification({message});
        }
    }

    async function handleBlockSave(model, isEdit = false) {
        try {
            if (!isEdit) {
                await createBlock(event.eventKey, model);
            } else {
                await editBlock(model);
                setEditableModel(blockModel);
            }
    
            getBlocksList();        
            setIsEditModalVisible(false);
        } catch ({message = null}) {
            if (message) showNotification({message});
        }
    }

    function handleBlockEdit(block) {
        setEditableModel(block);
        setIsEditModalVisible(true);
    }

    async function handleBlockDelete(block) {
        try {
            await deleteBlock(block.id);
            getBlocksList();
        } catch ({message = null}) {
            if (message) showNotification({message});
        }
    }

    function handleCloseModal() {
        setEditableModel(blockModel);
        setIsEditModalVisible(false);
    }

    function handlePreview(block = null) {
        if (!block) return;

        setPreviewBlock(block);
        setIsModalPreviewVisible(true);
    }

    return (
        <section className='block-constructor'>
            <Row>
                <Breadcrumb>
                    <LinkContainer to={`/event/${event.eventPassword}`}>
                        <Breadcrumb.Item>
                            Трансляция
                        </Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>
                        {locale('mainMenu.emails')}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {locale('mainMenu.emails.blocksEditor')}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Row>
            <br />
            <Row>
                <Col lg={12}>
                <Button
                    style={{display: 'block', marginLeft: 'auto'}}
                    onClick={() => setIsEditModalVisible(true)}
                >
                    Добавить блок
                </Button>
                </Col>
            </Row>
            <br />
            <Row>
                <Col lg={12}>
                    <BlocksList
                        blocks={blocksList || []}
                        onEdit={handleBlockEdit}
                        onDelete={handleBlockDelete}
                        onPreview={handlePreview}
                    />
                </Col>
            </Row>
            {
                isEditModalVisible &&
                <BlocksEditModal
                    isModalVisible={isEditModalVisible}
                    editableModel={editableModel}
                    event={event}
                    onSave={handleBlockSave}
                    onHide={handleCloseModal}
                />
            }
            <BlocksModalPreview
                isModalVisible={isModalPreviewVisible}
                block={previewBlock}
                onHide={setIsModalPreviewVisible}
                background={mailSettings?.darkColor ?? 'black'}
            />
        </section>
    )
};

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(BlockConstructor);
